// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.1',
  revision: '50208bad',
  branch: 'master',
  date: 'Thu, 02 Apr 2026 09:38:05 GMT'
};